import React, { useRef } from 'react';
import { Button, Input, InputNumber } from 'antd';
import DateInput from 'rsuite/DateInput';
import 'rsuite/DateInput/styles/index.css';
import { EditOutlined } from '@ant-design/icons';
import { DATE_FORMAT } from '../../../../../../utils/constansts/dates.constanst';

const { TextArea } = Input;

interface InputBorderNoneProps {
  type?: string;
  placeholder: string;
  label?: string | null;
  className?: string | null;
  calculateBalance?: boolean;
  valuePercentage?: number;
  onChange?: any;
  value?: any;
  height?: string | number;
  formatter?: 'currency' | any;
  max?: number;
  min?: number;
  color?: 'default' | 'warning' | 'bold' | 'bold-lith';
  disabled?: boolean;
  onBlur?: any;
  onKeyDown?: any;
  suffix?: any;
  defaultValue?: any;
  canEdit?: boolean;
  onEditClick?: any;
  multiline?: boolean;
}

const InputBorderNone = ({
  type,
  placeholder,
  label,
  calculateBalance,
  className,
  valuePercentage,
  onChange,
  value,
  height = 'auto',
  formatter,
  color,
  onBlur,
  multiline,
  ...props
}: InputBorderNoneProps) => {
  const ref = useRef<any>();

  const getFormatter: any = (value: string) => {
    if (value && formatter === 'currency')
      return `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '';
  };

  return (
    <div className={`InputBorderNone InputBorderNone-${type}`} style={{ height }}>
      {label && <p className="body-card">{label}</p>}
      {type === 'number' && (
        <InputNumber
          ref={ref}
          value={value}
          controls={false}
          className={`input input-transparent body-placeholder ${className} ${color}`}
          placeholder={placeholder}
          style={{ width: '100%' }}
          formatter={formatter && typeof formatter === 'string'? getFormatter: formatter}
          onChange={(v) => onChange(v, ref)}
          suffix={props.suffix}
          onKeyDown={(e) => {
            const input = e.currentTarget as HTMLInputElement;
            const val = input.value;
            if (
              (e.key === '-' && (val.includes('-') || input.selectionStart !== 0)) ||
              (e.key === '.' && val.includes('.'))
            ) {
              e.preventDefault();
            }
            props.onKeyDown?.(e);
          }}
          {...(!formatter ? { type: 'number' } : {})}
          {...props}
        />
      )}
      {type !== 'number' && type !== 'edit-number' && type !== 'edit-date' && !multiline && (
        <Input
          type={type}
          value={value}
          className={`input input-transparent body-placeholder ${className} ${color}`}
          placeholder={placeholder}
          onChange={onChange}
          {...props}
        />
      )}
      {multiline && (
        <TextArea
          value={value}
          className={`input input-transparent body-placeholder ${className} ${color}`}
          placeholder={placeholder}
          onChange={onChange}
          autoSize={{ minRows: 1 }}
          style={{ resize: 'none' }}
          {...props}
        />
      )}
      {type === 'edit-number' && (
        <div className="edit-number-container" style={{ display: 'flex', alignItems: 'center', gap: 8}}>
          <Input
            ref={ref}
            value={value}
            type="text"
            inputMode="numeric"
            className={`input input-transparent body-placeholder ${className} ${color}`}
            placeholder={placeholder}
            style={{ width: '100%' }}
            onChange={(e) => onChange(e.target.value)}
            suffix={props.suffix}
            onKeyDown={(e) => {
              props.onKeyDown?.(e);
            }}
            {...props}
          />
          {props.canEdit && (
            <Button
              type="text"
              icon={<EditOutlined/>}
              onClick={props.onEditClick}
              className="edit-date-button"
              />
          )}
        </div>
      )}
      {type === 'edit-date' && (
        <div className="edit-date-container" style={{ display: 'flex', alignItems: 'center', gap: 8}}>
          <DateInput
            placeholder='MM/DD/YYYY'
            format={DATE_FORMAT}
            value={value}
            onChange={(date) => onChange?.(date)}
            className='input-transparent'
            disabled={props.disabled}
            style={{ width: '100%', padding: 0 }}
            {...props}
          />
          {props.canEdit && (
            <Button
              type="text"
              icon={<EditOutlined/>}
              onClick={props.onEditClick}
              className="edit-date-button"
              />
          )}
        </div>
      )}
      {calculateBalance && (
        <div className="percentage-bottom">
          <span className="body-card">{valuePercentage}% of balance</span>
          <span className="body-regular">
            <span>$</span>
            {`${value / 2}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          </span>
        </div>
      )}
      {/* <p className="body-card">Account balance</p> */}
    </div>
  );
};

export default InputBorderNone;
